import React from "react";
import SmartLink from "../../shared/links/SmartLink";
import style from "../../../../src/assets/css/modules/contact-us/online-link.css";
import { ButtonConfig, Layouts } from "../../../constants/Constants";
import { getLayout } from "../../../layout/Layout";
import File from "../../../assets/img/card-images/File.png";
import FileHOL from "../../../assets/img/card-images/FileHol.png";

const UploadGPReferralLetter = (props) => {
  return (
      <SmartLink to={props.url} className={props.disableStyle?style.disabled:style.onlineLink} isExternalLink={props.featureFlagEP}
      isDisabled={props.isDisabled} id={ButtonConfig.UploadAGPreferralletter}
        >
       <img
                  src={getLayout()===Layouts.MOL?File:FileHOL}
                  className={style.fileImage}
                  alt=""
                  aria-hidden
                />
      <span>{props.linkText}</span>
    </SmartLink>
  );
};

export default UploadGPReferralLetter;